import React from 'react';

import Icon from './Icon';
import { IconProps } from './types';

const UpCaretIcon = (props: IconProps) => (
  <Icon {...props} style={{ transform: 'rotate(180deg)' }} src={'/icons/dropdown-caret-down.svg'} />
);

export default UpCaretIcon;
